var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgMobileMessages(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 20",
    fill: "none",
    stroke: "#5AFFC7",
    fillOpacity: 0,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M4.653 10.692a.692.692 0 100-1.385.692.692 0 000 1.385zM9.151 10.692a.692.692 0 100-1.385.692.692 0 000 1.385zM13.65 10.692a.692.692 0 100-1.385.692.692 0 000 1.385z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M9.497 1a8.995 8.995 0 00-8.984 9.428 9.002 9.002 0 001.496 4.557L.5 19l5.052-.914A8.996 8.996 0 0018.278 8.013 9.002 9.002 0 009.498 1v0z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMobileMessages;